const reports = [
    { name: "Bank Estimation Report", status: "available" ,sampleUrl: "/sample-reports/Bank-estimate-sample-myboq.pdf",},
    { name: "PWD Estimate with Rate Analysis Report", status: "available" ,sampleUrl: "/sample-reports/PWD-estimate-sample-myboq.pdf", },
    { name: "Schedule B", status: "available" ,sampleUrl: "/sample-reports/Schedule-B-Sample-myboq.pdf",}
  ];
  export default reports;